export const initSiteSearchBox = () => {
	const
		containerEl = document.querySelector('.header__bottom-searchbar-container'),
		el = containerEl?.querySelector('.form-control'),
		submitBtnEl = containerEl?.querySelector('.search-button'),
		toggleBtnEl = document.querySelector('.header__search-toggle');

	if (
		!el
		|| !containerEl
		|| !submitBtnEl
		|| !toggleBtnEl
	) {
		return;
	}

	//
	// Get the current search index.
	//

	let index;

	if (window.currentSearchIndex) {
		index = window.currentSearchIndex;
	} else {
		console.warn('No search index was set in the page context. Falling back to "html-content-index".');
		index = 'html-content-index';
	}

	//
	// Create the site search box instance.
	//

	createSiteSearchBox(index, { el, containerEl, submitBtnEl, toggleBtnEl });
};

/**
 * Creates a site search box instance.
 * @param {string} index - Search index.
 * @param {{
 *   el: HTMLInputElement;
 *   containerEl: HTMLElement;
 *   submitBtnEl: HTMLElement;
 *   toggleBtnEl: HTMLElement;
 * }} els - Search box elements.
 */
const createSiteSearchBox = (index, els) => {
	/**
	 * Whether the site search box is open.
	 */
	let isOpen = false;

	/**
	 * Opens the site search box.
	 */
	const open = () => {
		if (isOpen) {
			return;
		}

		els.containerEl.classList.add('header__bottom-searchbar-container--visible');
		els.toggleBtnEl.classList.add('header__search-toggle--close');
		els.toggleBtnEl.textContent = 'Close';

		els.containerEl.inert = false;
		document.body.dataset.siteSearchOpen = 'true';
		els.el.focus();

		isOpen = true;
	};

	/**
	 * Closes the site search box.
	 */
	const close = () => {
		if (!isOpen) {
			return;
		}

		els.containerEl.classList.remove('header__bottom-searchbar-container--visible');
		els.toggleBtnEl.classList.remove('header__search-toggle--close');
		els.toggleBtnEl.textContent = 'Search';

		els.containerEl.inert = true;
		document.body.dataset.siteSearchOpen = 'false';

		isOpen = false;
	};

	/**
	 * Toggles the site search box.
	 */
	const toggle = () => {
		if (isOpen) {
			close();
		} else {
			open();
		}
	};

	/**
	 * Navigates to the search results page using the provided search query.
	 * @param {string} query - Search query.
	 */
	const search = (query) => {
		const params = new URLSearchParams({
			indexCatalogue: index,
			searchQuery: encodeURIComponent(query)
		});

		const url = `/search-results?${params}`;

		location.assign(url);
	};

	/**
	 * Navigates to the search results page using the current search box value.
	 */
	const submit = () => {
		const query = els.el.value.trim();

		if (!query) {
			return;
		}

		search(query);
	};

	/**
	 * Closes the site search box when the user clicks outside of it.
	 * @param {MouseEvent} ev - Click event.
	 */
	const checkClickClose = (ev) => {

		// remember that `Node.contains` checks if the provided node is a
		// descendant OR if it is the node itself.

		if (
			els.containerEl.contains(ev.target)
			|| els.toggleBtnEl.contains(ev.target)
		) {
			return;
		}

		close();
	};

	/**
	 * Closes the site search box when the user presses the Escape key.
	 * @param {KeyboardEvent} ev - Keyboard event
	 */
	const checkKeyClose = (ev) => {
		if (ev.key !== 'Escape') {
			return;
		}

		close();
	};

	/**
	 * Attaches event listeners to the search box.
	 */
	const listen = () => {
		els.toggleBtnEl.addEventListener('click', toggle);
		els.submitBtnEl.addEventListener('click', submit);
		addEventListener('click', checkClickClose);
		addEventListener('keydown', checkKeyClose);
	};

	/**
	 * Detaches event listeners from the search box.
	 */
	const ignore = () => {
		els.toggleBtnEl.removeEventListener('click', toggle);
		els.submitBtnEl.removeEventListener('click', submit);
		removeEventListener('click', checkClickClose);
		removeEventListener('keydown', checkKeyClose);
	};

	//
	// Start listening to events.
	//

	listen();

	return {
		open,
		close,
		toggle,
		search,
		submit,
		listen,
		ignore
	};
};
